import React, { Component } from 'react';
import axios from 'axios';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import queryString from "query-string"


import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import InfiniteScroll from 'react-infinite-scroll-component';
import PopUp from "./PopUp";
import Slider from 'infinite-react-carousel';
import { Carousel } from 'react-responsive-carousel';
import moment from 'moment'

import { Link, animateScroll as scroll } from "react-scroll";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import Checkout from "./checkout";
import * as CurrencyFormat from 'react-currency-format';







const SimpleSlider = () => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    arrowsBlock: false,
  };

  return (
    <div>
      <Slider
        {...settings}

      >
        <div>
          <img src="http://theshipper.co.nz/1.png" className="iconfooter" />
        </div>
        <div>
          <img src="http://theshipper.co.nz/2.png" className="iconfooter" />
        </div>
        <div>
          <img src="http://theshipper.co.nz/3.png" className="iconfooter" />
        </div>

      </Slider>
    </div>
  );
};





const onClick2 = () => {
  window.location.href = "#fromaustralia";
};
const onClick3 = () => {
  window.location.href = "#fromnew";
};
const onClick4 = () => {
  window.location.href = "#toaustralia";
};
const onClick5 = () => {
  window.location.href = "#tonew";
};
const onClick6 = () => {
  window.location.href = "#quotepro";
};



const style = {
  height: 200,
  border: "0px solid green",
  margin: 6,
  padding: 8
};

const ButtonMailto = ({ mailto, label }) => {
  return (
    <Link
      to='#'
      onClick={(e) => {
        window.location = mailto;
        e.preventDefault();
      }}
    >
      {label}
    </Link>
  );
};


class FormTest extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      items: Array.from({ length: 1 }),
      hasMore: true,
      name: '',
      lastName: '',
      errorMessage: '',
      email: '',
      tel: '',
      lada: '',
      country: '',
      address: '',
      addressto: '',
      typecar: '',
      caravan: '',
      typecar1: '',
      car: '',
      pickup: '',
      delivery: '',
      vin: '',
      typecarq1: '',
      date: '',
      loading: true,
      posts: null,
      marine: false,
      compl: false,
      checked: true,
      errorMsg: '',
      statuscode: '',
      statuscode1: [
        {
          schedule: [0, 1
          ]
        }
      ],
      statuscode2: [],
      abierto: false,
      abrirStripe: false,
      abierto1: false,
      abierto2: false,
      abierto3: false,
      abierto4: false,
      abierto5: false,
      abierto6: false,
      abierto7: false,
      abierto8: false,
      abierto9: false,
      abierto10: false,
      abierto11: false,
      abierto12: false,
      abierto13: false,
      vehicletype: false,
      vehicletype1: false,
      vehicletype2: false,
      seen: false,
      proceed: false,
      spinner: false,
      pick1: 0,
      pick2: "df86ac07f0fe62abc08d8212a66f3508bb8136b",
      number: 1,
      compliance_pipe: 140,
      marine_pipe: 143,
      fromadelaide: '',
      fruits: [],
      from: 'Brisbane, Australia',
      fecha: '2020-12-30',
      inputValue: '',
      googleads:  '',
      specialdes: '',
      normaldes: '',
      cant: "",
      items: [],
      cart: [],
      vehicles: [
        {

          producto: "Motorbike",
          url: "https://theshipper.co.nz/images/Motorbike-min.jpg",
          type: 118,
          amount: 0,
          tipo: "special"
        },
        {

          producto: "Small",
          url: "https://theshipper.co.nz/images/Small-min.jpg",
          type: 119,
          amount: 0,
          tipo: "normal"
        },
        {

          producto: "Medium",
          url: "https://theshipper.co.nz/images/Medium-min.jpg",
          type: 130,
          amount: 0,
          tipo: "normal"
        },
        {

          producto: "Large",
          url: "https://theshipper.co.nz/images/Large-min.jpg",
          type: 131,
          amount: 0,
          tipo: "normal"
        },
        {

          producto: "Caravan",
          url: "https://theshipper.co.nz/images/Caravan-min.jpg",
          type: 122,
          amount: 0,
          tipo: "special"
        },
        {

          producto: "Motorhome",
          url: "https://theshipper.co.nz/images/Motorhome-min.jpg",
          type: 123,
          amount: 0,
          tipo: "special"
        },
        {
          producto: "Motorsport",
          url: "https://theshipper.co.nz/images/Motorsport-min.jpg",
          type: 128,
          amount: 0,
          tipo: "special"
        },
        {

          producto: "Personal Effects",
          url: "https://theshipper.co.nz/images/Motorhome-min.jpg",
          type: 124,
          amount: 0,
          tipo: "special"
        },
      ],
      client_secret: ''






    }

    this.handleChangecars = this.handleChangecars.bind(this);
    this.onValueChangeRadio = this.onValueChangeRadio.bind(this);


  }

  currencyOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }



  marinepipe = marine_pipe => {

    // Changing state
    this.setState({ marine_pipe: 141 })
  }


  marinepipe = compliance_pipe => {

    // Changing state
    this.setState({ compliance_pipe: 139 })
  }


  handleCheck = event => {
    this.setState({
      marine: event.target.checked

    });
  };

  handleCheck2 = event => {
    this.setState({
      compl: event.target.checked

    });
  };



  onValueChangeRadio(event) {
    this.setState({
      selectedOption: event.target.value
    });
    console.log(this.state.selectedOption)
  }
  updatepersonal(type) {
    const { vehicles: oldVehicles } = this.state;
  
    // Incrementar la cantidad solo para "Personal Effects"
    const updatedVehicles = oldVehicles.map(vehicle => {
      if (vehicle.type === type && vehicle.tipo === "special" && vehicle.producto === "Personal Effects") {
        return {
          ...vehicle,
          amount: vehicle.amount + 1
        };
      }
      return vehicle;
    });
  
    // Actualizar el estado de vehicles
    this.setState({ vehicles: updatedVehicles });
  
    // Agregar "personal effects" al estado de normaldes
    this.setState({ normaldes: "personal effects" });
  
    // Obtener el elemento con el ID "personal" y actualizar su contenido
    const personalElement = document.getElementById('personal');
    if (personalElement) {
      personalElement.innerText = "personal effects";
    }
  
    // Actualizar el estado de vehicletype
    this.setState({ vehicletype: !this.state.vehicletype });
  
    // Imprimir en la consola el estado actualizado de vehicles, normaldes y vehicletype
    console.log(this.state.vehicles);
    console.log(this.state.normaldes);
    console.log(this.state.vehicletype);
  }
  

  update(type) {
    const { vehicles: oldvehicles } = this.state;
    const vehicles = oldvehicles.map(p => {
      if (p.type === type) {
        p.amount += 1;
        return p;
      }
      return p;
    });

    this.setState(vehicles);
    console.log(this.state.vehicles);
  }

  updatemenos(type) {
    const { vehicles: oldvehicles } = this.state;
    const vehicles = oldvehicles.map(p => {
      if (p.type === type) {
        p.amount += -1;
        return p;
      }
      return p;
    });

    this.setState(vehicles);
    console.log(this.state.vehicles);
  }


  getTotal = () => {
    const total = this.state.cart.reduce((totalCost, item) => totalCost + item.price, 0);
    return total.toLocaleString(undefined, this.currencyOptions)
  }
  add = (product) => {
    this.setState(state => ({
      cart: [...state.cart, product],
    }))
    console.log(this.state.cart);
  }

  remove = (product) => {
    this.setState(state => {
      const cart = [...state.cart];
      const productIndex = cart.findIndex(p => p.name === product.name);
      if (productIndex < 0) {
        return;
      }
      cart.splice(productIndex, 1)
      return ({
        cart,
      })

    })
    console.log(this.state.cart);
  }

  onInputChange(e) {
    this.setState({
      inputValue: e.target.name,
      cant: e.target.value,

    });
  }

  addItem() {
    let items = this.state.items;
    items.push(this.state.inputValue, this.state.cant);
    this.setState({
      items
    });

    console.log(this.state.items);
  }
  listItems() {
    let items = this.state.items;
    return (
      <ul>
        {
          items.map((val, index) => {
            return (
              <li key={index}>
                {val}
              </li>
            );
          })
        }
      </ul>
    );
  }


  handleChangeform = event => {
    // use spread operator
    this.setState({
      form: [...this.state.form, event.target.value],
    }, () => {
      console.log(this.state.form);
    }
    );

  };


  handleChangecars(e) {
    if (e.target.value) {
      this.setState({
        cars: [...this.state.cars, e.target.value],
      }, () => {
        console.log(this.state.cars);
      });
    } else {
      let remove = this.state.cars.indexOf(e.target.value);
      this.setState({
        cars: this.state.cars.filter((_, i) => i !== remove)
      },
        () => {
          console.log('fruits', this.state.cars);
        }
      );
    }
  }







  togglePop = () => {
    this.setState({
      seen: !this.state.seen
    });
    setTimeout(() => {
      this.setState({
        seen: true,
      });
    }, 500);
  };


//from country
handleClickFromCountryAus = country => {

  // Changing state
  this.setState({ country: 174 })
}
handleClickFromCountryNz = country => {

  // Changing state
  this.setState({ country: 175 })
}


  // From Australia buttons
  // Changing state from buttons
  handleClickFromAde = address => {

    // Changing state
    this.setState({ address: 'Adelaide SA, Australia' })
  }
  // end Changing state from buttons
  handleClickFromBr = address => {

    // Changing state
    this.setState({ address: 'Brisbane QLD, Australia' })
  }
  // end Changing state from buttons
  handleClickFromMe = address => {

    // Changing state
    this.setState({ address: 'Melbourne VIC, Australia' })
  }
  // end Changing state from buttons
  handleClickFromPe = address => {

    // Changing state
    this.setState({ address: 'Perth WA, Australia' })
  }
  // end Changing state from buttons
  handleClickFromSy = address => {

    // Changing state
    this.setState({ address: 'Sydney NSW, Australia' })
  }
  // end Changing state from buttons

  // From New Zealand buttons
  // Changing state from buttons
  handleClickFromAc = address => {

    // Changing state
    this.setState({ address: 'Auckland, New Zealand' })
  }
  // end Changing state from buttons
  handleClickFromTa = address => {

    // Changing state
    this.setState({ address: 'Tauranga, New Zealand' })
  }
  // end Changing state from buttons
  handleClickFromWe = address => {

    // Changing state
    this.setState({ address: 'Wellington, New Zealand' })
  }
  // end Changing state from buttons
  handleClickFromNe = address => {

    // Changing state
    this.setState({ address: 'Nelson, New Zealand' })
  }
  // end Changing state from buttons
  handleClickFromCh = address => {

    // Changing state
    this.setState({ address: 'Christchurch, New Zealand' })
  }
  // end Changing state from buttons



  // To Australia buttons
  // Changing state from buttons
  handleClickToAde = address => {

    // Changing state
    this.setState({ addressto: 'Adelaide SA, Australia' })
  }
  // end Changing state from buttons
  handleClickToBr = addressto => {

    // Changing state
    this.setState({ addressto: 'Brisbane QLD, Australia' })
  }
  // end Changing state from buttonsG
  handleClickToMe = addressto => {

    // Changing state
    this.setState({ addressto: 'Melbourne VIC, Australia' })
  }
  // end Changing state from buttons
  handleClickToPe = addressto => {

    // Changing state
    this.setState({ addressto: 'Perth WA, Australia' })
  }
  // end Changing state from buttons
  handleClickToSy = addressto => {

    // Changing state
    this.setState({ addressto: 'Sydney NSW, Australia' })
  }
  // end Changing state from buttons

  // To New Zealand buttons
  // Changing state from buttons
  handleClickToAc = addressto => {

    // Changing state
    this.setState({ addressto: 'Auckland, New Zealand' })
  }
  // end Changing state from buttons
  handleClickToTa = addressto => {

    // Changing state
    this.setState({ addressto: 'Tauranga, New Zealand' })
  }
  // end Changing state from buttons
  handleClickToWe = addressto => {

    // Changing state
    this.setState({ addressto: 'Wellington, New Zealand' })
  }
  // end Changing state from buttons
  handleClickToNe = addressto => {

    // Changing state
    this.setState({ addressto: 'Nelson, New Zealand' })
  }
  // end Changing state from buttons
  handleClickToCh = addressto => {

    // Changing state
    this.setState({ addressto: 'Christchurch, New Zealand' })
  }
  // end Changing state from buttons



  changeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  handleChange = address => {
    this.setState({ address });
  };
  handleChange3 = address => {
    this.setState({ address });
  };
  handleChange1 = addressto => {
    this.setState({ addressto });
  };

  handleSelect = address => {
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => console.log('Success', latLng))
      .catch(error => console.error('Error', error));
  };

  handleSelect3 = address => {
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => console.log('Success', latLng))
      .catch(error => console.error('Error', error));
  };

  handleSelect1 = addressto => {
    geocodeByAddress(addressto)
      .then(results => getLatLng(results[0]))
      .then(latLng => console.log('Success', latLng))
      .catch(error => console.error('Error', error));
  };

  onclicitem = (address) => { this.setState({ address: address }) }
  onclicitem3 = (address) => { this.setState({ address: address }) }
  onclicitem2 = (addressto) => { this.setState({ addressto: addressto }) }




  abrirModal = () => {
    this.setState({ abierto: !this.state.abierto });
  }
  abrirStripe = () => {
    console.log('abrir');
    this.setState({ abrirStripe: !this.state.abrirStripe });
  }
  abrirModal1 = () => {
    this.setState({ abierto1: !this.state.abierto1 });
  }
  abrirModal2 = (country) => {
    this.setState({ abierto2: !this.state.abierto2 })
    this.setState({ country: 176 });
    
  }
  abrirModal3 = (country) => {
    this.setState({ abierto3: !this.state.abierto3 });
    this.setState({ country: 177 });

  }
  abrirModal4 = (country) => {
    this.setState({ abierto4: !this.state.abierto4 });
    this.setState({ country: 178 });

  }
  abrirModal5 = (country) => {
    this.setState({ abierto5: !this.state.abierto5 });
    this.setState({ country: 179 });

  }
  abrirModal6 = () => {
    this.setState({ abierto6: !this.state.abierto6 });

  }

  abrirModal7 = () => {
    this.setState({ abierto7: !this.state.abierto7 });
  }
  abrirModal8 = () => {
    this.setState({ abierto8: !this.state.abierto8 });
  }
  abrirModal9 = () => {
    this.setState({ abierto9: !this.state.abierto9 });
  }
  abrirModal10 = () => {
    this.setState({ abierto10: !this.state.abierto10 });
  }
  abrirModal11 = () => {
    this.setState({ abierto11: !this.state.abierto11 });
  }
  abrirModal12 = () => {
    this.setState({ abierto12: !this.state.abierto12 });
  }
  abrirModal13 = () => {
    this.setState({ abierto13: !this.state.abierto13 });
  }
  vehicletype = () => {
    this.setState({ vehicletype: !this.state.vehicletype });
  }
  vehicletype1 = () => {
    this.setState({ vehicletype1: !this.state.vehicletype1 });
  }
  vehicletype2 = () => {
    this.setState({ vehicletype2: !this.state.vehicletype2 });
  }
  proceed = () => {
    this.setState({ proceed: !this.state.proceed });
  }

  submitHandler = e => {
    const queryParams = queryString.parse(window.location.search);
    var myInt1 = parseInt(queryParams.utm_source); 
    var myInt2 = parseInt(queryParams.utm_campaign); 

    this.setState({ spinner: true });


    e.preventDefault()
    console.log(this.state)

    const body = {
      name: this.state.name,
      last_name: this.state.lastName,
      email: this.state.email,
      phone: this.state.lada + this.state.tel,
      ship_from: this.state.address,
      ship_to: this.state.addressto,
      vehicles: this.state.vehicles,
      title: "quote",
      estimated_shipping_date: this.state.date,
      description: this.state.normaldes,
      deal_source: myInt1,
      google_ads_campaign: myInt2,
      country_origin: this.state.country,




    };
    console.log(body);




    // axios.post('https://taktiko-quoter-nu4c57wzlq-an.a.run.app/api-quoter/quote',  body )

    axios.all([
      axios.post('https://api-quoter-ophdgerdoq-ts.a.run.app/api-quoter/quote', body),
      axios.get('https://api-quoter-ophdgerdoq-ts.a.run.app/api-quoter/quote/schedule?ship_from=' + this.state.from + '&estimated_shipping_date=' + this.state.fecha),
    ])


      .then(res => {
        // console.log(res.data);
        //console.log(res.status);
        console.log(res[0].data, 'data 1');
        console.log(res[1].data, 'data 2');
        console.log(res[0].status);
        console.log(res[1].status);
        this.setState({ statuscode: res[0].data, statuscode2: res[1].data.schedule, client_secret: res[0].data.client_secret });

        console.log("status 2", this.state.statuscode2);
        console.log("SPINNER", this.state.spinner);




      })

      .catch(error => {
        console.log(error)
        this.setState({
          errorMsg: 'QUOTE SUCCESSFULLY SUBMITED'
        })

      })



  }

  submitHandler2 = e => {
    this.setState({ spinner: true });
    e.preventDefault()
    console.log(this.state)

    const body = {
      name: this.state.name,
      last_name: this.state.lastName,
      email: this.state.email,
      phone: this.state.lada + this.state.tel,
      ship_from: this.state.address,
      ship_to: this.state.addressto,
      vehicles: this.state.vehicles,
      title: "PERSONAL EFFECTS",
      estimated_shipping_date: this.state.date,
      org_id: 765,
      description: this.state.normaldes,
      deal_source: 78,
      google_ads_campaign: 89


    };
    console.log(body);




    // axios.post('https://taktiko-quoter-nu4c57wzlq-an.a.run.app/api-quoter/quote',  body )

    axios.all([
      axios.post('https://taktiko-quoter-nu4c57wzlq-an.a.run.app/api-quoter/quote', body),
      axios.get('https://taktiko-quoter-nu4c57wzlq-an.a.run.app/api-quoter/quote/schedule?ship_from=' + this.state.from + '&estimated_shipping_date=' + this.state.fecha),
    ])


      .then(res => {
        // console.log(res.data);
        //console.log(res.status);
        console.log(res[0].data);
        console.log(res[1].data);
        console.log(res[0].status);
        console.log(res[1].status);
        this.setState({ statuscode: res[0].data });
        this.setState({ statuscode2: res[1].data.schedule });
        console.log("status 2", this.state.statuscode2);
        console.log("SPINNER", this.state.spinner);

      })

      .catch(error => {
        console.log(error)
        this.setState({
          errorMsg: 'QUOTE SUCCESSFULLY SUBMITED'
        })

      })



  }



  //partir en 2 pasos el update de marine, compliance y final price en el boton de proceder
  submitupdate = e => {
    e.preventDefault()
    const body1 = {
      "0df86ac07f0fe62abc08d8212a66f3508bb8136b": this.state.pickup,
      "ece02b109cbde393755b4f674776ab62ef2dbdb7": 141,
      "deb9fc14b50fea14d1c8de57a7171b5921951195": 139,
      "d9962f5dc2fabd97cd068ebcd9c664d89f50a17c": "2021-01-01",
      "e2f1b2908b93fc0530ffda9ed6efc86aac67bfbd": this.state.delivery,
      "ae4aaef18813ad05ef95050300ae34c17a94f25a": 106


    };
    const id = this.state.statuscode.deal_id;

    console.log(body1);
    console.log(id);
    axios.patch("https://taktiko-quoter-nu4c57wzlq-an.a.run.app/api-quoter/quote/deal/" + id, body1)


      .then(res => {
        console.log(res.data);
        console.log(res.status);
      })
  }


  fetchMoreData = () => {
    if (this.state.items.length >= 1) {
      this.setState({ hasMore: true });
      return;
    }
    // a fake async api call like which sends
    // 20 more records in .5 secs
    setTimeout(() => {
      this.setState({
        items: this.state.items.concat(Array.from({ length: 1 }))
      });
    }, 5);
  };

  render() {

    const { name, lastName, email, tel, address, addressto, car, vin, delivery, pickup, vehicles, date, posts, marine, compl, errorMsg, statuscode, statuscode2, specialdes, normaldes, lada } = this.state
    const data = this.state.posts;

    const emaildata = this.state.name + " " + this.state.address + " " + this.state.addressto + " - Contact for the GET QUOTE";

    const queryParams = queryString.parse(window.location.search);


    console.warn(posts);

    const quote_price = statuscode ? statuscode.final_price : 0;
    const totalvalue = statuscode.final_vcd + statuscode.final_vco + statuscode.final_ais;
    const totaldes = totalvalue * 0.50;
    let total = totalvalue;
    if (marine) total += statuscode.final_marine;
    if (compl) total += statuscode.final_compliance;


    async function handleToken(token, addresses) {
      const response = await axios.post(
        "http://localhost:5000/checkout", { token, totaldes }
      );

      console.log(response.status)

      console.log(response.status)

      if (response.status === 200) {
        toast("Success! Payment Completed", { type: "success" });
      } else {
        toast("Something went wrong", { type: "error" });
      }



    }







    return (


      <div>


        <div className="App-header">
          <div className="App-header-div">
            <img src="http://theshipper.co.nz/shipper/01_Horizontal_Blue&White_Over_Blue.png" className="logo" />

          </div>

          {this.state.address ?
            <div className="App-header-div-white">
              <a href="#from" className="linkheader">
                <h3>Shipping From </h3>

                <h3 className="headerstatus" maxlength="1">{this.state.address} </h3>
                <h2></h2>
              </a>
            </div>
            : null}
          {this.state.addressto ?
            <div className="App-header-div-white">
              <a href="#to" className="linkheader">
                <h3>Shipping To </h3>
                <h3 className="headerstatus">{this.state.addressto} </h3>
              </a>
            </div >
            : null}
          {this.state.date ?
            <div className="App-header-div-white">
              <a href="#date" className="linkheader">
                <h3 >Estimated Shipping Date </h3>
                <h3 className="headerstatus">{moment(this.state.date).format("MMMM Do YYYY")}{" "} </h3>
              </a>
            </div>
            : null}


          {this.state.vehicletype2 ? null

            :
            <div className="App-header-div-whitee">
              {vehicles.filter(vehicle => vehicle.amount != 0).map(p => (
                <div className="App-header-div-white">
                  <a href="#date" className="linkheader">
                    <h3 >Cargo Select </h3>
                    <h3 className="headerstatus">{p.amount} X {p.producto} vehicle</h3>
                  </a>
                </div>


              ))}</div>
          }

        </div>
        <div className="btn" onClick={this.togglePop}>


        </div>

        {this.state.normaldes ? null :
          <div>
            {/* SECTION FROM */}

            <div className="padre">
              <div className="hijo">


                <div className="msection" id="from">


                  <h1 className="titlefrom">SHIPPING FROM </h1>
                  
                   {/* <h4 className="descriptionstep">Select one of the options below</h4>*/}

                  <div className="msectionbtn">


                    <div className="item">

                      <Link
                        activeClass="active"
                        to="fromaustralia"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        className="itemh"
                        onClick={this.handleClickFromCountryAus}
                      >
                        <span className="centext">
                          Australia
                        </span>
                      </Link>


                    </div>
                    <div className="item">
                      <Link
                        activeClass="active"
                        to="fromnew"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        className="itemh"
                        onClick={this.handleClickFromCountryNz}
                      >
                        <span className="centext2">
                          New Zealand
                        </span>              </Link>


                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal2}>  United Kingdom </Button>



                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal3}>  United States</Button>



                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal4}>  South Africa</Button>



                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal5}>  Rest of the World</Button>


                    </div>
                  </div>







                  <div className="autocompleteboxdiv">
                    {this.state.abierto2 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>

                        <PlacesAutocomplete
                          value={address}
                          defaultValue="hola"
                          onChange={this.handleChange}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect}
                          location={-34, 151}
                          radius={2000}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}

                    {this.state.abierto3 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>
                        <PlacesAutocomplete
                          value={address}
                          onChange={this.handleChange}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem3(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}

                    {this.state.abierto4 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>
                        <PlacesAutocomplete
                          value={address}
                          onChange={this.handleChange}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}

                    {this.state.abierto5 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>
                        <PlacesAutocomplete
                          value={address}
                          onChange={this.handleChange}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect}
                          placeholder="Number / Street / City / Zip Code"

                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}


                  </div>
                  {this.state.address ?


                    <div className="siguiente">
                      <Link
                        id='from1'
                        activeClass="active"
                        to="to"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{ cursor: 'pointer' }}              >
                        <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                      </Link>
                    </div>
                    : null}




                </div>
              </div>
            </div>
            {/* SECTION FROM AUSTRALIA */}

            <div className="padre">
              <div className="hijo">


                <div className="msection " id="fromaustralia">
                  <hr />
                  <Link
                    activeClass="active"
                    to="from"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
                  </Link>

                  <hr />
                  <h1 className="title">SHIPPING FROM AUSTRALIA</h1>
                   {/* <h4 className="descriptionstep">Select one of the options below</h4>*/}
                  <div className="msectionbtn">

                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromAde}>  Adelaide</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromBr}>  Brisbane</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromMe}>  Melbourne</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromPe}>  Perth</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromSy}>  Sydney</Button>
                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal6}>  Other Location</Button>

                    </div>


                  </div>
                  <p className="km"> Select one of our Depots or click on "Other Location" for a Door collection </p>

                  {this.state.abierto6 ?
                    <div className="">

                      <p className="autocompletep">complete details below </p>
                      <PlacesAutocomplete
                        value={address}
                        onChange={this.handleChange}
                        googleCallbackName="myCallbackFunc"
                        onSelect={this.handleSelect}
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>

                            <input onChange={this.changeHandler} className="btn"

                              {...getInputProps({
                                placeholder: 'Number / Street / City / Zip Code',
                                className: 'location-search-input',
                              })}

                            />

                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: '#43242', cursor: 'pointer' }
                                  : { backgroundColor: '#43242', cursor: 'pointer' };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </div> : null}
                  {this.state.address ?
                    <div className="">

                      <div className="siguiente"><Link
                        activeClass="active"
                        to="to"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{ cursor: 'pointer' }}              >
                        <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                      </Link>
                      </div>
                    </div> : null}
                </div>

              </div>
            </div>
            {/* SECTION FROM NEW ZEALAND */}

            <div className="padre">
              <div className="hijo">
                <div className="msection " id="fromnew">
                  <Link
                    activeClass="active"
                    to="from"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
                  </Link>

                  <hr />
                  <h1 className="title"> SHIPPING FROM NEW ZEALAND</h1>
                   {/* <h4 className="descriptionstep">Select one of the options below</h4>*/}
                  <div className="msectionbtn">
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromAc}>  Auckland</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromTa}>  Tauranga</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromWe}>  Wellington</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickFromNe}>  Nelson</Button>
                    </div>
                    <div className="item">
                      <Button className="itemhc textfrom" type="" onClick={this.handleClickFromCh}>  Christchurch</Button>
                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal7}>  Other Location</Button>

                    </div>

                  </div>
                  <p className="km">Select one of our Depots or click on "Other Location" for a Door collection  </p>

                  {this.state.abierto7 ?
                    <div className="">
                      <p className="autocompletep">complete details below </p>
                      <PlacesAutocomplete
                        value={address}
                        onChange={this.handleChange}
                        googleCallbackName="myCallbackFunc"
                        onSelect={this.handleSelect}
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>

                            <input onChange={this.changeHandler} className="btn"

                              {...getInputProps({
                                placeholder: 'Number / Street / City / Zip Code',
                                className: 'location-search-input',
                              })}

                            />

                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: '#43242', cursor: 'pointer' }
                                  : { backgroundColor: '#43242', cursor: 'pointer' };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                  </div>
                                );
                              })}

                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      {this.state.address ?


                        <div className="siguiente"><Link
                          activeClass="active"
                          to="to"
                          spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          style={{ cursor: 'pointer' }}              >
                          <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                        </Link>
                        </div>
                        : null}
                    </div> : null}
                    {this.state.address ?
                    <div className="">

                      <div className="siguiente"><Link
                        activeClass="active"
                        to="to"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{ cursor: 'pointer' }}              >
                        <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                      </Link>
                      </div>
                    </div> : null}
                </div>
              </div>
            </div>
            {/* SECTION TO */}

            <div className="padre" id="to">
              <div className="hijo">
                <div className="msection">
                  <hr />

                  <Link
                    activeClass="active"
                    to="from"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
                  </Link>
                  <h1 className="title">SHIPPING TO</h1>
                   {/* <h4 className="descriptionstep">Select one of the options below</h4>*/}
                  <div className="msectionbtn">


                    <div className="item">

                      <Link
                        activeClass="active"
                        to="toaustralia"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        className="itemh"
                      >
                        <span className="centext">
                          AUSTRALIA
                        </span>
                      </Link>


                    </div>
                    <div className="item">
                      <Link
                        activeClass="active"
                        to="tonew"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        className="itemh"
                      >
                        <span className="centext2">
                          New Zealand
                        </span>               </Link>


                    </div>

                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal8}>  United Kingdom </Button>



                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal9}>  United States</Button>



                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal10}>  South Africa</Button>



                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal11}>  Rest of the World</Button>

                    </div>
                  </div>

                  <div className="autocompleteboxdiv">
                    {this.state.abierto8 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>

                        <PlacesAutocomplete
                          value={addressto}
                          defaultValue="hola"
                          onChange={this.handleChange1}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect1}
                          location={-34, 151}
                          radius={2000}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}

                    {this.state.abierto9 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>
                        <PlacesAutocomplete
                          value={addressto}
                          onChange={this.handleChange1}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect1}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem3(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}

                    {this.state.abierto10 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>
                        <PlacesAutocomplete
                          value={addressto}
                          onChange={this.handleChange1}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect1}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}

                    {this.state.abierto11 ?
                      <div className="autocompletebox">
                        <p className="autocompletep">complete details below </p>
                        <PlacesAutocomplete
                          value={addressto}
                          onChange={this.handleChange1}
                          googleCallbackName="myCallbackFunc"
                          onSelect={this.handleSelect1}
                          placeholder="Number / Street / City / Zip Code"

                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>

                              <input onChange={this.changeHandler} className="btn"

                                {...getInputProps({
                                  placeholder: 'Number / Street / City / Zip Code',
                                  className: 'location-search-input',
                                })}

                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? { backgroundColor: '#43242', cursor: 'pointer' }
                                    : { backgroundColor: '#43242', cursor: 'pointer' };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <p onClick={() => this.onclicitem(suggestion.description)}>  {suggestion.description}</p>

                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </div> : null}


                  </div>
                  {this.state.address ?


<div className="siguiente">
  <Link
    id='from1'
    activeClass="active"
    to="date"
    spy={true}
    smooth={true}
    offset={-70}
    duration={500}
    style={{ cursor: 'pointer' }}              >
    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
  </Link>
</div>
: null}

                </div>
              </div>
            </div>

            {/* SECTION TO AUSTRALIA */}

            <div className="padre">
              <div className="hijo">
                <div className="msection " id="toaustralia">
                  <hr />

                  <Link
                    activeClass="active"
                    to="to"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
                  </Link>
                  <h1 className="title">SHIPPING TO AUSTRALIA</h1>
                   {/* <h4 className="descriptionstep">Select one of the options below</h4>*/}
                  <div className="msectionbtn">
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToAde} value="adelaide">  Adelaide</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToBr}>  Brisbane</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToMe}>  Melbourne</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToPe}>  Perth</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToSy}>  Sydney</Button>
                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal12}>  Other Location</Button>

                    </div>

                  </div>
                  <p className="km"> Metro areas or select "Other Location" for a different city.</p>

                  {this.state.abierto12 ?
                    <div className="">
                      <p className="autocompletep">complete details below </p>
                      <PlacesAutocomplete
                        value={addressto}
                        onChange={this.handleChange1}
                        googleCallbackName="myCallbackFunc"
                        onSelect={this.handleSelect1}
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>

                            <input onChange={this.changeHandler} className="btn"

                              {...getInputProps({
                                placeholder: ' Number / Street / City / Zip Code',
                                className: 'location-search-input',
                              })}

                            />

                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: '#43242', cursor: 'pointer' }
                                  : { backgroundColor: '#43242', cursor: 'pointer' };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <p onClick={() => this.onclicitem2(suggestion.description)}>  {suggestion.description}</p>

                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      
                    </div> : null}

                    {this.state.addressto ?


<div className="siguiente">
  <Link
    activeClass="active"
    to="date"
    spy={true}
    smooth={true}
    offset={-70}
    duration={500}
    style={{ cursor: 'pointer' }}              >
    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
  </Link>
</div>
: null}
                </div>
              </div>
            </div>

            {/* SECTION TO NEW ZEALAND */}

            <div className="padre">
              <div className="hijo">
                <div className="msection " id="tonew">
                  <ht />
                  <ht />

                  <Link
                    activeClass="active"
                    to="to"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
                  </Link>
                  <h1 className="title">SHIPPING TO NEW ZEALAND</h1>
                   {/* <h4 className="descriptionstep">Select one of the options below</h4>*/}
                  <div className="msectionbtn">
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToAc} value="">  Auckland</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToTa}>  Tauranga</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToWe}>  Wellington</Button>
                    </div>
                    <div className="item">
                      <Button className="itemh textfrom" type="" onClick={this.handleClickToNe}>  Nelson</Button>
                    </div>
                    <div className="item">
                      <Button className="itemhc textfrom" type="" onClick={this.handleClickToCh}>  Christchurch</Button>
                    </div>
                    <div className="item"><Button className="itemh textfrom" type="" onClick={this.abrirModal13}>  Other Location</Button>


                    </div>

                  </div>
                  <p className="km">Metro areas or select "Other Location" for a different city.
                  </p>
                  {this.state.abierto13 ?
                    <div className="">
                      <p className="autocompletep">complete details below </p>
                      <PlacesAutocomplete
                        value={addressto}
                        onChange={this.handleChange1}
                        googleCallbackName="myCallbackFunc"
                        onSelect={this.handleSelect1}
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>

                            <input onChange={this.changeHandler} className="btn"

                              {...getInputProps({
                                placeholder: ' Number / Street / City / Zip Code',
                                className: 'location-search-input',
                              })}

                            />

                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: '#43242', cursor: 'pointer' }
                                  : { backgroundColor: '#43242', cursor: 'pointer' };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <p onClick={() => this.onclicitem2(suggestion.description)}>  {suggestion.description}</p>

                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      {this.state.addressto ?


                        <div className="siguiente">
                          <Link
                            activeClass="active"
                            to="date"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            style={{ cursor: 'pointer' }}              >
                            <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                          </Link>
                        </div>
                        : null}
                    </div> : null}
                  {this.state.addressto ?
                    <div className="">



                      <div className="siguiente"><Link
                        activeClass="active"
                        to="date"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{ cursor: 'pointer' }}              >
                        <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                      </Link>
                      </div>
                    </div> : null}

                </div>
              </div>

            </div>






            {/* SECTION DATE */}


            <div className="msection" id="date">
              <Link
                activeClass="active"
                to="from"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
              </Link>
              <hr />

              <h1 htmlFor="date" className="title">Estimated Shipping date</h1>
              <p className="selectdate"> select date from the calendar</p>

              <span className="datepicker-toggle">
                <span class="datepicker-toggle-button"></span>
                <input
                  type="date"
                  className="datepicker-input"
                  name="date"
                  id="date"
                  value={date}
                  onChange={this.changeHandler} />

              </span>
              {this.state.date ? <p className="shipment">{moment(this.state.date).format("MMMM Do YYYY")}{" "}</p> : null}
              {this.state.date ?


                <div className="siguiente">
                  <Link
                    activeClass="active"
                    to="cargo"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    style={{ cursor: 'pointer' }}              >
                    <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                  </Link>
                </div>
                : null}
            </div>
          

        {/* SECTION CARGO */}
          <div className="msectioncargo" id="cargo">
            <hr />
            <Link
              activeClass="active"
              to="date"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
            </Link>

            <h1 className="msectioncargotitulo"> What Are We Shipping?</h1>
            <div className="msectioncargobtn">
              <Button className="itemhcargo textfrom" type="" onClick={this.vehicletype}>  VEHICLES </Button>
              <Button className="itemhcargo1 textfrom" type="" onClick={this.vehicletype2}>  PERSONAL EFFECTS</Button>


            </div>

            <div className="padre">
              <div className="hijo">

                <div>
                  <div className="padre">
                    {this.state.vehicletype2 ?
                      <div className="hijo">
                        <p className="personaleffects">Click the button to download and complete our Personal Effects spreadsheet.</p>
                        <div className="itemp">

                          {vehicles.filter(vehicle => vehicle.type == "124").map(p => (
                            <div key={p.type} className="hijotype">


                              <div>
                                <Link
                                  activeClass="active"
                                  to="personal"
                                  onClick={() => this.updatepersonal(p.type)}
                                  spy={true}
                                  smooth={true}
                                  offset={-70}
                                  duration={500}
                                  style={{ cursor: 'pointer' }}              >
                                  <div className="btn11">

                                    DOWNLOAD

                                  </div>
                                </Link>




                              </div>


                            </div>
                          ))}






                        </div>
                      </div> : this.state.vehicletype1}



                  </div>




                  <div className="padretype">

                    {this.state.vehicletype ?
                      <Carousel showThumbs={false} showStatus={false} autoPlay={true}>
                        {vehicles.filter(vehicle => vehicle.type == "118").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>

                            <div>

                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>

                          </div>
                        ))}

                        {vehicles.filter(vehicle => vehicle.type == "119").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>
                            <div>
                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>
                          </div>
                        ))}

                        {vehicles.filter(vehicle => vehicle.type == "130").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>
                            <div>
                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>
                          </div>
                        ))}

                        {vehicles.filter(vehicle => vehicle.type == "131").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>
                            <div>
                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>
                          </div>
                        ))}

                        {vehicles.filter(vehicle => vehicle.type == "122").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>
                            <div>
                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>
                          </div>
                        ))}

                        {vehicles.filter(vehicle => vehicle.type == "123").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>
                            <div>
                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>
                          </div>
                        ))}

                        {vehicles.filter(vehicle => vehicle.type == "128").map(p => (
                          <div key={p.type} className="hijotype">

                            <div><span role="img" ><img src={p.url} className="itemcart"></img></span></div>
                            <div>
                              <button type="button" onClick={() => this.updatemenos(p.type)} className="productobtn">-</button>
                              <div className="productoamount">{p.amount}</div>
                              <button type="button" onClick={() => this.update(p.type)} className="productobtn">+</button>



                            </div>
                          </div>
                        ))}
                      </Carousel> : null}




                     {this.state.vehicletype2 ? null

                            :
                            <div className="App-header-div-whitee">
                              {vehicles.filter(vehicle => vehicle.amount != 0).map(p => (
                                <div className="padre">
                                <div className="hijo">
                                  <div className="siguientecargoselect">
                                    <Link
                                      activeClass="active"
                                      to="cargodescription"
                                      spy={true}
                                      smooth={true}
                                      offset={-70}
                                      duration={500}
                                      style={{ cursor: 'pointer' }}              >
                                      <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                                    </Link>
                                  </div>
                                </div>
                              </div> 


                              ))}</div>
                            }

                  </div>





                </div>
              </div>
            </div>









          </div>
          </div>}


        {/* SECTION CARGO DESCRIPTION */}
        {this.state.name ? null :

          <div>
            <div className="msectioncargo" id="cargodescription">
              <hr />
              {this.state.normaldes ? null :
              <Link
                activeClass="active"
                to="cargo"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
              </Link> }


              <h1 className="title"> VEHICLE DETAILS </h1>

              <div className="padretype">



                <div className="padre">
                  <div className="hijo">
                    <div className="cargortagdiv">  {vehicles.filter(vehicle => vehicle.amount != 0).map(p => (

                      <div className="cargotag">{p.amount}X {p.producto} VEHICLE </div>

                    ))}
                    </div>
                    <p className="msectioncargodes"> complete details below  </p>

                    <textarea
                      name="normaldes"
                      id="normaldes"
                      type="text"
                      placeholder="VEHICLE DETAILS..."



                      value={normaldes}
                      onChange={this.changeHandler}
                      className="inputcargo"

                    />
                    <p className="msectionestimade"> Year - Make - Model - Estimated Value NZD </p>

                    {this.state.normaldes ?

                      <div className="siguiente">

                        <Link
                          activeClass="active"
                          to="personal"
                          spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          style={{ cursor: 'pointer' }}              >
                          <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtn parpadea" />
                        </Link>

                      </div> : null}
                  </div>
                </div>
              </div>

            </div>
          </div>}

        {/* SECTION PERSONAL */}

        {this.state.normaldes ?  
        <div className="msection" id="personal">

               <div className="specialbtn">

                {errorMsg ? <div className="msectionquote" id="quote">
                  <div className="">


                    <div className="div-completo" >


                      <div className="AppForm2">

                        <div className="Blank">




                          <strong>  <h1 className="quotetitle">Thank you for visiting the Shipper LTD. <hr />

                            One of our specialists will contact you shortly. <hr />

                            The Shipper LTD. - Shipping Dreams All Around The World.


                          </h1></strong>



                          <div className="logoquotediv">
                            <img src="http://theshipper.co.nz/shipper/01_Icon_Blue_Over_White.png" className="logoquote"></img>
                          </div>

                        </div>

                      </div>



                    </div>


                  </div>
                </div>
                  : null

                }


                {this.state.statuscode ?

                  <div className="msectionquote" id="quote">
                    <div className="">


                      <div className="div-completo" >


                        <div className="AppForm2">

                          <div className="Blank">
                            <div className="statusid">
                              <p className="statusidd">{this.state.name}: Quote Number: SHIP <strong>{statuscode.deal_id}</strong></p>
                            </div>
                            <strong>  <h1 className="quotetitle" id='shippingd'>SHIPPING DREAMS</h1></strong>
                            <p className="quotetext"> Shipping from <a className="quoteroll">{this.state.address}</a> Shipping to <a className="quoteroll"> {this.state.addressto}</a> </p>
                            <p className="quotetext1"> Roll-On/ Roll-Off transportation service. </p>

                            <table>
                              <tr>
                                <td>Local Cartage And Delivery to wharf  <div class="tooltip"><img src="http://theshipper.co.nz/info.png" className="informacion"></img> <span class="tooltiptext">- We only use certified port approved transporters with Marine Security License
                                </span></div></td>
                                <td>
                                  <CurrencyFormat value={statuscode.final_vco} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>{value} NZD</div>} />
                                </td>
                                <td>
                                  <label class="container" id="c1">
                                    <input name="marine"
                                      id="marine"
                                      type="checkbox"
                                      checked={this.state.checked}
                                    />

                                    <span class="checkmark"></span>
                                  </label>
                                </td>

                              </tr>
                              <tr>
                                <td>All Inclusive Shipping Rate <div class="tooltip"><img src="http://theshipper.co.nz/info.png" className="informacion"></img>
                                  <span class="tooltiptext"> - This rate includes:<hr />
                                    Export documentation <hr />
                                    Freight & port charges<hr />
                                    New Zealand Customs clearance<hr />
                                    MPI and NZTA inspections<hr />
                                    Transport to a local Compliance Centre.<hr />

                                    Approximate transit time of {statuscode.transit_time} days.
                                  </span></div> </td>
                                <td>
                                  <CurrencyFormat value={statuscode.final_ais} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>{value} NZD</div>} />
                                </td>
                                <td>
                                  <label class="container" id="c1">
                                    <input name="marine"
                                      id="marine"
                                      type="checkbox"
                                      checked={this.state.checked}

                                    />
                                    <span class="checkmark"></span>
                                  </label>

                                </td>

                              </tr>
                              {statuscode.final_vcd == 0 ? null : <tr>
                                <td>Vehicle Delivery at Destination  </td>
                                <td>
                                  <CurrencyFormat value={statuscode.final_vcd} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>{value} NZD</div>} />
                                </td>
                                <td>
                                  <label class="container" id="c1">
                                    <input name="marine"
                                      id="marine"
                                      type="checkbox"
                                      checked={this.state.checked}

                                    />
                                    <span class="checkmark blink"></span>
                                  </label>
                                </td>

                              </tr>}
                              <tr>
                                <td>Marine Insurance <div class="tooltip"><img src="http://theshipper.co.nz/info.png" className="informacion"></img> <span class="tooltiptext">Shipping lines, transitional facilities and transporters are subject to limited liability. <hr />

                                  We strongly recommend you to take our Marine Insurance to be protected in the unlikely damage event. </span></div>


                                </td>
                                {statuscode.final_marine <= 0 ? <td>To Be Updated</td> :
                                  <td>
                                    <CurrencyFormat value={statuscode.final_marine} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>{value} NZD</div>} />
                                  </td>

                                }

                                <td>
                                  <label class="container" id="c1">
                                    <input name="marine"
                                      id="marine"
                                      type="checkbox"
                                      checked={marine}
                                      onChange={this.handleCheck}
                                    />
                                    <span class="checkmark blink"></span>
                                  </label>

                                </td>

                              </tr>

                              <tr>
                                <td>Vehicle Compliance / WOF   </td>
                                <td>
                                  <CurrencyFormat value={statuscode.final_compliance} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>{value} NZD</div>} />
                                </td>
                                <td>
                                  <label class="container" id="c1">
                                    <input type="checkbox" checked={compl}
                                      onChange={this.handleCheck2} />

                                    <span class="checkmark blink"></span>
                                  </label>

                                </td>

                              </tr>

                            </table>
                            <p className="quotetext2"> *Rate for vehicle(s) in full driving conditions, no personal effects and to be confirmed once we receive all your information.  </p>
                            <p className="quotetext3"> Full details have been sent to the email provided</p>

                            <p>
                              <div className="totalnzd">
                                <p className="totalnzd1">
                                  <CurrencyFormat value={total} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>TOTAL {value} NZD + APPLICABLE LOCAL GST</div>} />
                                </p>
                              </div>
                              <div className="payservice">
                                <CurrencyFormat value={totaldes} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div> TO LOCK THE RATE AND PROCCED WITH YOUR TRANSPORTATION JOURNEY WE REQUIRE A 50% DEPOSIT {value} NZD</div>} />

                              </div>
                            </p>
                            <p>


                              <Button className="btn11" type="" onClick={this.abrirStripe} id="reservequote">  RESERVE</Button>
                              <Button className="btn11" type="" onClick={this.abrirModal} id="contactquote">  Contact The Shipper</Button>

                              <Modal isOpen={this.state.abierto} className="modal">
                                <ModalHeader>
                                  <h1>Contact</h1>
                                  <p>Thank you for visiting the Shipper LTD. </p>
                                  <p>If you have any questions, let us know. We are always happy to help. </p>
                                  <p>The Shipper LTD. - Shipping Dreams All Around The World.</p>
                                </ModalHeader>
                                <ModalBody>


                                  <a className="btnemail" href={"mailto:" + "info@theshipper.co.nz" + "?subject=" + emaildata + "&body=" + "please place the quantity and information of your vehicle "}>  SEND EMAIL</a>

                                  <a className="btncall" href="tel:+6499425806" >  CALL</a>

                                </ModalBody>
                                <ModalFooter>

                                  <Button className="closemodal" type="" onClick={this.abrirModal}>X</Button>

                                </ModalFooter>
                              </Modal>



                              <Modal isOpen={this.state.abrirStripe} className="modal payment-modal-stripe">
                                <ModalHeader>
                                  <h1>RESERVE a 50% <strong><CurrencyFormat value={totaldes} displayType={'text'} thousandSeparator={true} prefix={'$'} renderText={value => <div>{value}</div>} /> </strong></h1>
                                </ModalHeader>
                                <ModalBody>
                                  <Checkout clientSecret={this.state.client_secret} />
                                </ModalBody>
                                <ModalFooter>

                                  <Button className="closepay" type="" onClick={this.abrirStripe}> X</Button>

                                </ModalFooter>
                              </Modal>



                            </p>

                            <div className="logoquotediv">
                              <img src="http://theshipper.co.nz/shipper/01_Icon_Blue_Over_White.png" className="logoquote"></img>
                            </div>

                          </div>

                        </div>



                      </div>


                    </div>
                  </div>
                  :    
                  <div id="">
                      {this.state.spinner ? <div id=""> <img src="https://theshipper.co.nz/images/icon_loading.png" className="iconloading blink" /> 
                      <div id="">
                      <span id="">LOADING... </span>
                      </div>
                      </div> :
                  
                  <div>
                    

                    {this.state.name ? null :


                      
                    <Link
                      activeClass="active"
                      to="cargodescription"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      <img src="http://theshipper.co.nz/shipper/back.png" className="iconbtnback" />
                    </Link>}

                    
                    <h1 className='title'>PERSONAL DETAILS</h1>
                    <p className="msectioncargodes"> complete details below  </p>
                    <div> <input
                      name="name"
                      id="name"
                      type="text"
                      placeholder="First Name"
                      value={name}
                      onChange={this.changeHandler}
                      className="input"

                    />
                    </div>
                    <div> <input
                      name="lastName"
                      id="lastName"
                      type="text"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={this.changeHandler}
                      className="input"

                    /></div>

                    <div><label htmlFor="email"></label></div>
                    <div><input
                      name="email"
                      id="email"
                      type="text"
                      placeholder="Email"
                      value={email}
                      onChange={this.changeHandler}
                      className="input"

                    /></div>
                    <div>
                      <div className="select select">

                        <select
                          name="lada"
                          id="lada"
                          value={lada}
                          onChange={this.changeHandler}
                          className="input">
                          <option data-countryCode="NZ" value="64">New Zealand (+64)</option>
                          <option data-countryCode="AU" value="61">Australia (+61)</option>

                          <optgroup label="Other countries">
                            <option data-countryCode="GB" value="44" Selected>UK (+44)</option>
                            <option data-countryCode="DZ" value="213">Algeria (+213)</option>
                            <option data-countryCode="AD" value="376">Andorra (+376)</option>
                            <option data-countryCode="AO" value="244">Angola (+244)</option>
                            <option data-countryCode="AI" value="1264">Anguilla (+1264)</option>
                            <option data-countryCode="AG" value="1268">Antigua &amp; Barbuda (+1268)</option>
                            <option data-countryCode="AR" value="54">Argentina (+54)</option>
                            <option data-countryCode="AM" value="374">Armenia (+374)</option>
                            <option data-countryCode="AW" value="297">Aruba (+297)</option>
                            <option data-countryCode="AU" value="61">Australia (+61)</option>
                            <option data-countryCode="AT" value="43">Austria (+43)</option>
                            <option data-countryCode="AZ" value="994">Azerbaijan (+994)</option>
                            <option data-countryCode="BS" value="1242">Bahamas (+1242)</option>
                            <option data-countryCode="BH" value="973">Bahrain (+973)</option>
                            <option data-countryCode="BD" value="880">Bangladesh (+880)</option>
                            <option data-countryCode="BB" value="1246">Barbados (+1246)</option>
                            <option data-countryCode="BY" value="375">Belarus (+375)</option>
                            <option data-countryCode="BE" value="32">Belgium (+32)</option>
                            <option data-countryCode="BZ" value="501">Belize (+501)</option>
                            <option data-countryCode="BJ" value="229">Benin (+229)</option>
                            <option data-countryCode="BM" value="1441">Bermuda (+1441)</option>
                            <option data-countryCode="BT" value="975">Bhutan (+975)</option>
                            <option data-countryCode="BO" value="591">Bolivia (+591)</option>
                            <option data-countryCode="BA" value="387">Bosnia Herzegovina (+387)</option>
                            <option data-countryCode="BW" value="267">Botswana (+267)</option>
                            <option data-countryCode="BR" value="55">Brazil (+55)</option>
                            <option data-countryCode="BN" value="673">Brunei (+673)</option>
                            <option data-countryCode="BG" value="359">Bulgaria (+359)</option>
                            <option data-countryCode="BF" value="226">Burkina Faso (+226)</option>
                            <option data-countryCode="BI" value="257">Burundi (+257)</option>
                            <option data-countryCode="KH" value="855">Cambodia (+855)</option>
                            <option data-countryCode="CM" value="237">Cameroon (+237)</option>
                            <option data-countryCode="CA" value="1">Canada (+1)</option>
                            <option data-countryCode="CV" value="238">Cape Verde Islands (+238)</option>
                            <option data-countryCode="KY" value="1345">Cayman Islands (+1345)</option>
                            <option data-countryCode="CF" value="236">Central African Republic (+236)</option>
                            <option data-countryCode="CL" value="56">Chile (+56)</option>
                            <option data-countryCode="CN" value="86">China (+86)</option>
                            <option data-countryCode="CO" value="57">Colombia (+57)</option>
                            <option data-countryCode="KM" value="269">Comoros (+269)</option>
                            <option data-countryCode="CG" value="242">Congo (+242)</option>
                            <option data-countryCode="CK" value="682">Cook Islands (+682)</option>
                            <option data-countryCode="CR" value="506">Costa Rica (+506)</option>
                            <option data-countryCode="HR" value="385">Croatia (+385)</option>
                            <option data-countryCode="CU" value="53">Cuba (+53)</option>
                            <option data-countryCode="CY" value="90392">Cyprus North (+90392)</option>
                            <option data-countryCode="CY" value="357">Cyprus South (+357)</option>
                            <option data-countryCode="CZ" value="42">Czech Republic (+42)</option>
                            <option data-countryCode="DK" value="45">Denmark (+45)</option>
                            <option data-countryCode="DJ" value="253">Djibouti (+253)</option>
                            <option data-countryCode="DM" value="1809">Dominica (+1809)</option>
                            <option data-countryCode="DO" value="1809">Dominican Republic (+1809)</option>
                            <option data-countryCode="EC" value="593">Ecuador (+593)</option>
                            <option data-countryCode="EG" value="20">Egypt (+20)</option>
                            <option data-countryCode="SV" value="503">El Salvador (+503)</option>
                            <option data-countryCode="GQ" value="240">Equatorial Guinea (+240)</option>
                            <option data-countryCode="ER" value="291">Eritrea (+291)</option>
                            <option data-countryCode="EE" value="372">Estonia (+372)</option>
                            <option data-countryCode="ET" value="251">Ethiopia (+251)</option>
                            <option data-countryCode="FK" value="500">Falkland Islands (+500)</option>
                            <option data-countryCode="FO" value="298">Faroe Islands (+298)</option>
                            <option data-countryCode="FJ" value="679">Fiji (+679)</option>
                            <option data-countryCode="FI" value="358">Finland (+358)</option>
                            <option data-countryCode="FR" value="33">France (+33)</option>
                            <option data-countryCode="GF" value="594">French Guiana (+594)</option>
                            <option data-countryCode="PF" value="689">French Polynesia (+689)</option>
                            <option data-countryCode="GA" value="241">Gabon (+241)</option>
                            <option data-countryCode="GM" value="220">Gambia (+220)</option>
                            <option data-countryCode="GE" value="7880">Georgia (+7880)</option>
                            <option data-countryCode="DE" value="49">Germany (+49)</option>
                            <option data-countryCode="GH" value="233">Ghana (+233)</option>
                            <option data-countryCode="GI" value="350">Gibraltar (+350)</option>
                            <option data-countryCode="GR" value="30">Greece (+30)</option>
                            <option data-countryCode="GL" value="299">Greenland (+299)</option>
                            <option data-countryCode="GD" value="1473">Grenada (+1473)</option>
                            <option data-countryCode="GP" value="590">Guadeloupe (+590)</option>
                            <option data-countryCode="GU" value="671">Guam (+671)</option>
                            <option data-countryCode="GT" value="502">Guatemala (+502)</option>
                            <option data-countryCode="GN" value="224">Guinea (+224)</option>
                            <option data-countryCode="GW" value="245">Guinea - Bissau (+245)</option>
                            <option data-countryCode="GY" value="592">Guyana (+592)</option>
                            <option data-countryCode="HT" value="509">Haiti (+509)</option>
                            <option data-countryCode="HN" value="504">Honduras (+504)</option>
                            <option data-countryCode="HK" value="852">Hong Kong (+852)</option>
                            <option data-countryCode="HU" value="36">Hungary (+36)</option>
                            <option data-countryCode="IS" value="354">Iceland (+354)</option>
                            <option data-countryCode="IN" value="91">India (+91)</option>
                            <option data-countryCode="ID" value="62">Indonesia (+62)</option>
                            <option data-countryCode="IR" value="98">Iran (+98)</option>
                            <option data-countryCode="IQ" value="964">Iraq (+964)</option>
                            <option data-countryCode="IE" value="353">Ireland (+353)</option>
                            <option data-countryCode="IL" value="972">Israel (+972)</option>
                            <option data-countryCode="IT" value="39">Italy (+39)</option>
                            <option data-countryCode="JM" value="1876">Jamaica (+1876)</option>
                            <option data-countryCode="JP" value="81">Japan (+81)</option>
                            <option data-countryCode="JO" value="962">Jordan (+962)</option>
                            <option data-countryCode="KZ" value="7">Kazakhstan (+7)</option>
                            <option data-countryCode="KE" value="254">Kenya (+254)</option>
                            <option data-countryCode="KI" value="686">Kiribati (+686)</option>
                            <option data-countryCode="KP" value="850">Korea North (+850)</option>
                            <option data-countryCode="KR" value="82">Korea South (+82)</option>
                            <option data-countryCode="KW" value="965">Kuwait (+965)</option>
                            <option data-countryCode="KG" value="996">Kyrgyzstan (+996)</option>
                            <option data-countryCode="LA" value="856">Laos (+856)</option>
                            <option data-countryCode="LV" value="371">Latvia (+371)</option>
                            <option data-countryCode="LB" value="961">Lebanon (+961)</option>
                            <option data-countryCode="LS" value="266">Lesotho (+266)</option>
                            <option data-countryCode="LR" value="231">Liberia (+231)</option>
                            <option data-countryCode="LY" value="218">Libya (+218)</option>
                            <option data-countryCode="LI" value="417">Liechtenstein (+417)</option>
                            <option data-countryCode="LT" value="370">Lithuania (+370)</option>
                            <option data-countryCode="LU" value="352">Luxembourg (+352)</option>
                            <option data-countryCode="MO" value="853">Macao (+853)</option>
                            <option data-countryCode="MK" value="389">Macedonia (+389)</option>
                            <option data-countryCode="MG" value="261">Madagascar (+261)</option>
                            <option data-countryCode="MW" value="265">Malawi (+265)</option>
                            <option data-countryCode="MY" value="60">Malaysia (+60)</option>
                            <option data-countryCode="MV" value="960">Maldives (+960)</option>
                            <option data-countryCode="ML" value="223">Mali (+223)</option>
                            <option data-countryCode="MT" value="356">Malta (+356)</option>
                            <option data-countryCode="MH" value="692">Marshall Islands (+692)</option>
                            <option data-countryCode="MQ" value="596">Martinique (+596)</option>
                            <option data-countryCode="MR" value="222">Mauritania (+222)</option>
                            <option data-countryCode="YT" value="269">Mayotte (+269)</option>
                            <option data-countryCode="MX" value="52">Mexico (+52)</option>
                            <option data-countryCode="FM" value="691">Micronesia (+691)</option>
                            <option data-countryCode="MD" value="373">Moldova (+373)</option>
                            <option data-countryCode="MC" value="377">Monaco (+377)</option>
                            <option data-countryCode="MN" value="976">Mongolia (+976)</option>
                            <option data-countryCode="MS" value="1664">Montserrat (+1664)</option>
                            <option data-countryCode="MA" value="212">Morocco (+212)</option>
                            <option data-countryCode="MZ" value="258">Mozambique (+258)</option>
                            <option data-countryCode="MN" value="95">Myanmar (+95)</option>
                            <option data-countryCode="NA" value="264">Namibia (+264)</option>
                            <option data-countryCode="NR" value="674">Nauru (+674)</option>
                            <option data-countryCode="NP" value="977">Nepal (+977)</option>
                            <option data-countryCode="NL" value="31">Netherlands (+31)</option>
                            <option data-countryCode="NC" value="687">New Caledonia (+687)</option>
                            <option data-countryCode="NZ" value="64">New Zealand (+64)</option>
                            <option data-countryCode="NI" value="505">Nicaragua (+505)</option>
                            <option data-countryCode="NE" value="227">Niger (+227)</option>
                            <option data-countryCode="NG" value="234">Nigeria (+234)</option>
                            <option data-countryCode="NU" value="683">Niue (+683)</option>
                            <option data-countryCode="NF" value="672">Norfolk Islands (+672)</option>
                            <option data-countryCode="NP" value="670">Northern Marianas (+670)</option>
                            <option data-countryCode="NO" value="47">Norway (+47)</option>
                            <option data-countryCode="OM" value="968">Oman (+968)</option>
                            <option data-countryCode="PW" value="680">Palau (+680)</option>
                            <option data-countryCode="PA" value="507">Panama (+507)</option>
                            <option data-countryCode="PG" value="675">Papua New Guinea (+675)</option>
                            <option data-countryCode="PY" value="595">Paraguay (+595)</option>
                            <option data-countryCode="PE" value="51">Peru (+51)</option>
                            <option data-countryCode="PH" value="63">Philippines (+63)</option>
                            <option data-countryCode="PL" value="48">Poland (+48)</option>
                            <option data-countryCode="PT" value="351">Portugal (+351)</option>
                            <option data-countryCode="PR" value="1787">Puerto Rico (+1787)</option>
                            <option data-countryCode="QA" value="974">Qatar (+974)</option>
                            <option data-countryCode="RE" value="262">Reunion (+262)</option>
                            <option data-countryCode="RO" value="40">Romania (+40)</option>
                            <option data-countryCode="RU" value="7">Russia (+7)</option>
                            <option data-countryCode="RW" value="250">Rwanda (+250)</option>
                            <option data-countryCode="SM" value="378">San Marino (+378)</option>
                            <option data-countryCode="ST" value="239">Sao Tome &amp; Principe (+239)</option>
                            <option data-countryCode="SA" value="966">Saudi Arabia (+966)</option>
                            <option data-countryCode="SN" value="221">Senegal (+221)</option>
                            <option data-countryCode="CS" value="381">Serbia (+381)</option>
                            <option data-countryCode="SC" value="248">Seychelles (+248)</option>
                            <option data-countryCode="SL" value="232">Sierra Leone (+232)</option>
                            <option data-countryCode="SG" value="65">Singapore (+65)</option>
                            <option data-countryCode="SK" value="421">Slovak Republic (+421)</option>
                            <option data-countryCode="SI" value="386">Slovenia (+386)</option>
                            <option data-countryCode="SB" value="677">Solomon Islands (+677)</option>
                            <option data-countryCode="SO" value="252">Somalia (+252)</option>
                            <option data-countryCode="ZA" value="27">South Africa (+27)</option>
                            <option data-countryCode="ES" value="34">Spain (+34)</option>
                            <option data-countryCode="LK" value="94">Sri Lanka (+94)</option>
                            <option data-countryCode="SH" value="290">St. Helena (+290)</option>
                            <option data-countryCode="KN" value="1869">St. Kitts (+1869)</option>
                            <option data-countryCode="SC" value="1758">St. Lucia (+1758)</option>
                            <option data-countryCode="SD" value="249">Sudan (+249)</option>
                            <option data-countryCode="SR" value="597">Suriname (+597)</option>
                            <option data-countryCode="SZ" value="268">Swaziland (+268)</option>
                            <option data-countryCode="SE" value="46">Sweden (+46)</option>
                            <option data-countryCode="CH" value="41">Switzerland (+41)</option>
                            <option data-countryCode="SI" value="963">Syria (+963)</option>
                            <option data-countryCode="TW" value="886">Taiwan (+886)</option>
                            <option data-countryCode="TJ" value="7">Tajikstan (+7)</option>
                            <option data-countryCode="TH" value="66">Thailand (+66)</option>
                            <option data-countryCode="TG" value="228">Togo (+228)</option>
                            <option data-countryCode="TO" value="676">Tonga (+676)</option>
                            <option data-countryCode="TT" value="1868">Trinidad &amp; Tobago (+1868)</option>
                            <option data-countryCode="TN" value="216">Tunisia (+216)</option>
                            <option data-countryCode="TR" value="90">Turkey (+90)</option>
                            <option data-countryCode="TM" value="7">Turkmenistan (+7)</option>
                            <option data-countryCode="TM" value="993">Turkmenistan (+993)</option>
                            <option data-countryCode="TC" value="1649">Turks &amp; Caicos Islands (+1649)</option>
                            <option data-countryCode="TV" value="688">Tuvalu (+688)</option>
                            <option data-countryCode="UG" value="256">Uganda (+256)</option>
                            <option data-countryCode="GB" value="44">UK (+44)</option>
                            <option data-countryCode="UA" value="380">Ukraine (+380)</option>
                            <option data-countryCode="AE" value="971">United Arab Emirates (+971)</option>
                            <option data-countryCode="UY" value="598">Uruguay (+598)</option>
                            <option data-countryCode="US" value="1">USA (+1)</option>
                            <option data-countryCode="UZ" value="7">Uzbekistan (+7)</option>
                            <option data-countryCode="VU" value="678">Vanuatu (+678)</option>
                            <option data-countryCode="VA" value="379">Vatican City (+379)</option>
                            <option data-countryCode="VE" value="58">Venezuela (+58)</option>
                            <option data-countryCode="VN" value="84">Vietnam (+84)</option>
                            <option data-countryCode="VG" value="84">Virgin Islands - British (+1284)</option>
                            <option data-countryCode="VI" value="84">Virgin Islands - US (+1340)</option>
                            <option data-countryCode="WF" value="681">Wallis &amp; Futuna (+681)</option>
                            <option data-countryCode="YE" value="969">Yemen (North)(+969)</option>
                            <option data-countryCode="YE" value="967">Yemen (South)(+967)</option>
                            <option data-countryCode="ZM" value="260">Zambia (+260)</option>
                            <option data-countryCode="ZW" value="263">Zimbabwe (+263)</option>
                          </optgroup>
                        </select>
                      </div>
                    </div>


                    <div><label htmlFor="tel"></label></div>
                    <div>



                      <input
                        name="tel"
                        id="tel"
                        type="text"
                        placeholder="Phone Number"
                        value={tel}
                        onChange={this.changeHandler}
                        className="input1"

                      /></div>
                    {/*submitHandler*/}

                    {this.state.tel ?
                     

                     

                    <div id="getquotesom"><button className="btn11" type="submit" onClick={this.submitHandler} id="getquotesom"> 

                     <span id="getquotesom">GET QUOTE   </span>
                    
                     </button></div> 
                     
                    
                    
                    
                    : null}

                    
                  </div>
                  }</div> 

                } </div>
                









 
        </div> : null }


        {/* SECTION FOOTER */}


        <div class="footerstatus">
          <div className="padrestatus">

            <div className="hijostatus">

              <div className="circulo1">SHIPMENT</div>
              <div className="linea1"></div>
              <div className="circulo1">DATE</div>
              <div className="linea2"></div>
              <div className="circulo1">CARGO</div>
              <div className="linea3"></div>
              <div className="circulo1">QUOTE</div>

            </div>
          </div>
          <div className="padrestatus">

            <div className="hijostatus">

              {this.state.addressto ? <img className="circuloc" src="http://theshipper.co.nz/shipper/check1.png" /> : <img className="circulo" src="http://theshipper.co.nz/shipper/check0.png" />}
              <div className="linea">0</div>
              {this.state.date ? <img className="circuloc" src="http://theshipper.co.nz/shipper/check1.png" /> : <img className="circulo" src="http://theshipper.co.nz/shipper/check0.png" />}
              <div className="linea">0</div>
              {this.state.vehicletype ? <img className="circuloc" src="http://theshipper.co.nz/shipper/check1.png" /> : <img className="circulo" src="http://theshipper.co.nz/shipper/check0.png" />}
              <div className="linea">0</div>
              {this.state.statuscode ? <img className="circuloc" src="http://theshipper.co.nz/shipper/check1.png" /> : <img className="circulo" src="http://theshipper.co.nz/shipper/check0.png" />}



            </div>
          </div>
        </div>
        <div class="footer">

          <SimpleSlider />

        </div>







      </div>
    );
  }

}

export default FormTest;

//https://api-quoter-ophdgerdoq-ts.a.run.app/api-quoter/quote
